import React, { useState, useEffect, useRef } from "react";
//import "rsuite/dist/rsuite.min.css";
import { Form } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { Col } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Container from "react-bootstrap/Container";
import AuthService from "../../../services/auth.service";
import Modal from "react-bootstrap/Modal";
import check from "../../../picture/check.png";
import Select from "react-select";
import { color, style } from "@mui/system";
import "./Styles.css";
import AuthServiceV2 from "../../../services/auth.serviceV2";
import Static_modal from "../etc/Static_modal";
function StatusDronelast() {
  let Navigate = useNavigate();
  function editdrone() {
    //setDisabless(false);
    Navigate("/profile/editprofileuser", {
      state: {
        href: window.location.href,
      },
    });
  }
  const prevent = () => {
    Navigate("/checksora", {
      state: {
        post_id: true,
      },
    });
  };
  const myStyle = {
    paddingTop: "60px",
  };
  const myStyle1 = {
    paddingTop: "30px",
    color: "#0077B6",
  };
  const { state } = useLocation();
  const form1 = useRef();
  const [checkuserdata, setcheckuserdata] = useState(false);
  const [validated, setValidated] = useState(false);
  const [data, setData] = useState("");
  const [dataEdit, setDataEdit] = useState("");
  const [show, setShow] = useState(false);
  const [senddata, setSenddata] = useState(false);
  const [updatedata, setUpdatedata] = useState(false);
  const [updatedatasuc, setUpdatedatasuc] = useState(false);
  const [docsave, setDocsave] = useState(false);
  const [install_eq, setInstall_eq] = useState("-");
  const [weight, setWeight] = useState(true);
  const [stdRemoteID, setStdRemoteID] = useState(true);
  const [frequency, setFrequency] = useState({
    checkbox1: 1,
    checkbox2: 0,
    checkbox3: 0,
    checkbox4: 0,
  });
  const [purpose, setPurpose] = useState({
    checkbox1: 1,
    checkbox2: 0,
    checkbox3: 0,
    checkbox4: 0,
    checkbox5: 0,
    checkbox6: 0,
    checkbox7: 0,
  });
  //const [lic_request, setLic_request] = useState();
  const [lic_req_data, setLic_req_data] = useState("");
  const [lic_req_data1, setLic_req_data1] = useState("");
  const [lic_req_data2, setLic_req_data2] = useState("");
  const [remote_sn, setRemote_sn] = useState(false);
  const [remote_brand, setRemote_brand] = useState(false);
  const [ins_type, setIns_type] = useState(false);
  const [ins_number, setIns_number] = useState(false);
  const [ins_company_name, setIns_company_name] = useState(false);
  const [ins_limit, setIns_limit] = useState(false);
  const [ins_start, setIns_start] = useState(false);
  const [ins_end, setIns_end] = useState(false);
  const [model, setModel] = useState("GGGG"); ///mockup
  const [droneserial, setDroneserial] = useState(""); ///mockup
  const [brand, setBrand] = useState("TOYO"); ///mockup
  const [disabless, setDisabless] = useState(true);

  const [chooselicense, setChooselicense] = useState();
  const [alllicreqdata, setAlllicreqdata] = useState([]);
  const [modalToggle, setModalToggle] = useState({
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });
  const [textBody, setTextBody] = useState();
  const handleClose_Modal = (close) => {
    setModalToggle({
      ...modalToggle,
      modalSuccess: close,
      modalDenied: close,
      modalErr: close,
      modalwait: close,
    });
    setTextBody("");
  };
  const handleOptionChange = (event) => {
    setChooselicense(event.target.value);
  };

  const handleClose = () => {
    setShow(false);
    setSenddata(false);
    setUpdatedata(false);
    setUpdatedatasuc(false);
    setcheckuserdata(false);
    Navigate("/user/drone/statusDrone");
  };
  const checkelemet = (abb) => {
    const element = document.getElementById(abb);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  const handleSend = (e) => {
    e.preventDefault();
    if (chooselicense === "1") {
      if (!lic_req_data.trim()) {
        checkelemet("choos1_1");
      }
      if (!lic_req_data1.trim()) {
        checkelemet("choos1_2");
      }
    }
    if (chooselicense === "2") {
      if (!lic_req_data.trim()) {
        checkelemet("choos2_1");
      }
      if (!lic_req_data1.trim()) {
        checkelemet("choos2_2");
      }
    }
    if (chooselicense === "3") {
      if (!lic_req_data.trim()) {
        checkelemet("choos3_1");
      }
      if (!lic_req_data1.trim()) {
        checkelemet("choos3_2");
      }
    }
    if (chooselicense === "5") {
      if (!lic_req_data.trim()) {
        checkelemet("choos5_1");
      }
      if (!lic_req_data1.trim()) {
        checkelemet("choos5_2");
      }
      if (!lic_req_data2.trim()) {
        checkelemet("choos5_3");
      }
    }
    if (!ins_start.trim()) {
      checkelemet("ins_start");
    }
    if (!ins_end.trim()) {
      checkelemet("ins_end");
    }

    if (!ins_limit) {
      checkelemet("ins_limit");
    }
    if (!ins_company_name.trim()) {
      checkelemet("ins_company_name");
    }
    if (!ins_number.trim()) {
      checkelemet("ins_number");
    }
    if (!ins_type.trim()) {
      checkelemet("ins_type");
    }

    if (!remote_brand.trim()) {
      checkelemet("remote_brand");
    }
    if (!remote_sn.trim()) {
      checkelemet("remote_sn");
    }
    if (!install_eq.trim()) {
      checkelemet("drone_install_eq");
    }

    if (!model.trim()) {
      checkelemet("drone_model");
    }
    if (!brand.trim()) {
      checkelemet("drone_brand");
    }
    if (!droneserial.trim()) {
      checkelemet("drone_sn");
    }

    console.log(form1.current.checkValidity());

    if (form1.current.checkValidity() === false) {
      //e.preventDefault();
      //e.stopPropagation();
    } else {
      //e.preventDefault();
      setShow(true);
    }
    setValidated(true);
    if (parseInt(chooselicense) === 4) {
    } else {
      if (parseInt(chooselicense) === 5) {
        setAlllicreqdata([lic_req_data, lic_req_data1, lic_req_data2]);
      } else {
        console.log(lic_req_data1);
        setAlllicreqdata([lic_req_data, lic_req_data1]);
      }
    }
  };
  const handleSendsuc = () => {
    setDocsave(false);
    setShow(false);
    //setSenddata(true);

    register(false);
  };
  const handleCheckboxChange = (event) => {
    console.log(frequency);
    const { name, checked } = event.target;
    const value = checked ? 1 : 0;
    setFrequency((prevCheckboxes) => ({
      ...prevCheckboxes,
      [name]: value,
    }));
  };
  const handleCheckboxpurposeChange = (event) => {
    const { name, checked } = event.target;
    const value = checked ? 1 : 0;
    setPurpose((prevCheckboxes) => ({
      ...prevCheckboxes,
      [name]: value,
    }));
  };
  const handleUpdate = (e) => {
    //console.log(form1.current.checkValidity());
    //console.log(typeof(ins_limit))
    if (form1.current.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      e.preventDefault();

      setUpdatedata(true);
    }

    setValidated(true);
  };
  const handleUpdatesuc = (e) => {
    e.preventDefault();
    setUpdatedata(false);
    setUpdatedatasuc(true);
    setDocsave(true);
    register(true);
  };
  const next = () => {
    setShow(false);
    setSenddata(false);
    setUpdatedata(false);
    Navigate("/user/drone/statusDrone");
  };
  const register = (doc_save) => {
    const lastpurpose = []
    const allfrequency = [
      frequency.checkbox1,
      frequency.checkbox2,
      frequency.checkbox3,
      frequency.checkbox4,
    ];
    const allpurpose = [
      purpose.checkbox1,
      purpose.checkbox2,
      purpose.checkbox3,
      purpose.checkbox4,
      purpose.checkbox5,
      purpose.checkbox6,
      purpose.checkbox7,
    ];
    for (let i = 0; i <= allpurpose.length; i++) {
      if(allpurpose[i]===1){
        lastpurpose.push(i+1)
      }
      
    }
    // if (parseInt(chooselicense) === 4) {
    // } else {
    //   if (parseInt(chooselicense) === 5) {
    //     setAlllicreqdata([lic_req_data, lic_req_data1, lic_req_data2]);
    //   } else {
    //     setAlllicreqdata([lic_req_data, lic_req_data1]);
    //   }
    // }
    const checktype = sessionStorage.getItem("type_user");
    if (checktype === "corporation") {
      AuthServiceV2.UpdateDroneDataStatus8ForCorp(
        state.drone_id,
        droneserial,
        brand,
        model,
        install_eq,
        remote_sn,
        remote_brand,
        stdRemoteID,
        ins_type,
        ins_number,
        ins_company_name,
        ins_limit,
        ins_start,
        ins_end,
        doc_save,
        weight,
        allfrequency,
        lastpurpose,
        parseInt(chooselicense),
        alllicreqdata
      ).then(
        (Response) => {
          console.log(Response);
          setSenddata(true);
          //Navigate("/statusDrone");
        }
      )
      .catch((error)=>{
        setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });

      })
    } else {
      AuthServiceV2.UpdateDroneReturnWithRegulator(
        state.drone_id,
        droneserial,
        brand,
        model,
        install_eq,
        remote_sn,
        remote_brand,
        stdRemoteID,
        ins_type,
        ins_number,
        ins_company_name,
        ins_limit,
        ins_start,
        ins_end,
        doc_save,
        weight,
        allfrequency,
        lastpurpose,
        parseInt(chooselicense),
        alllicreqdata
      ).then(
        (Response) => {
          console.log(Response);
          setSenddata(true);
          //Navigate("/statusDrone");
        }
      ).catch((error)=>{
        setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });

      })
    }
  };
  // useEffect(() => {
  //   //setDronereqnum(state.dronereq_id);
  //   const check = AuthServiceV2.getonedatadrone(state.drone_id);
  //   if (check != null)
  //     check.then((response) => {
  //       console.log(response);
  //       setPurpose(response.data.drone_data.purpose);
  //       setFrequency(response.data.drone_data.frequency);
  //       //setDatadrone(response.data.drone_data);
  //       setData(response.data.drone_data.userdata);
  //     });
  // }, [state]);
  useEffect(() => {
    if (state != null) {
      const check = AuthServiceV2.getonedatadrone(state.drone_id);
      if (check != null) {
        check.then((res) => {
          const datas = res.data.drone_data;
          console.log(typeof datas.built_in_rid);
          if (datas.built_in_rid === 1) {
            setStdRemoteID(true);
          } else {
            setStdRemoteID(false);
          }
          //setStdRemoteID(datas.built_in_rid)
          setDroneserial(datas.drone_serial_number);
          setBrand(datas.drone_brand);
          setModel(datas.drone_model);
          setInstall_eq(datas.install_eq);
          setRemote_brand(datas.controller_brand);
          setRemote_sn(datas.controller_serial_number);
          setWeight(datas.weight);
          setIns_type(datas.ins_type);
          setIns_number(datas.ins_number);
          setIns_company_name(datas.ins_company_name);
          setIns_limit(datas.ins_limit);
          setIns_start(datas.ins_start);
          setIns_end(datas.ins_end);
          setFrequency({
            checkbox1: datas.frequency[0],
            checkbox2: datas.frequency[1],
            checkbox3: datas.frequency[2],
            checkbox4: datas.frequency[3],
          });
          console.log(datas.weight);
          //setWeight(datas.weight);
          let temppur = [0,0,0,0,0,0]
        for(let i =0 ;i<= 6;i++){
          
          if(datas.purpose[i]===1){
            temppur[0]=1
          }else if(datas.purpose[i]===2){
            temppur[1]=2
          }
          else if(datas.purpose[i]===3){
            temppur[2]=3
          }
          else if(datas.purpose[i]===4){
            temppur[3]=4
          }
          else if(datas.purpose[i]===5){
            temppur[4]=5
          }
          else if(datas.purpose[i]===6){
            temppur[5]=6
          }
          
          
        }
        setPurpose(temppur)
          setChooselicense(datas.lic_request.toString());
          console.log(lic_req_data);
          if (datas.lic_req_data.length === 1) {
            setLic_req_data(datas.lic_req_data[0]);
          }
          if (datas.lic_req_data.length === 2) {
            console.log("sdsd");
            setLic_req_data(datas.lic_req_data[0]);
            setLic_req_data1(datas.lic_req_data[1]);
          }
          if (datas.lic_req_data.length === 3) {
            setLic_req_data(datas.lic_req_data[0]);
            setLic_req_data1(datas.lic_req_data[1]);
            setLic_req_data2(datas.lic_req_data[2]);
          }

          //setDataEdit(res.data.drone_data);
        }).catch((error)=>{
          setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });

        })
      }
    }
    console.log(state);
  }, []);
  useEffect(() => {
    const checktype = sessionStorage.getItem("type_user");
    if (checktype === "corporation") {
      const checkcorpertation = AuthServiceV2.corporationdata();
      if (checkcorpertation != null) {
        checkcorpertation.then(function (result) {
          setData(result.data.data);
          console.log(result);
        }).catch((error)=>{
          setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });

        })
      }
    } else {
      const check = AuthServiceV2.getCurrentUser();
      if (check != null)
        check.then(function (result) {
          console.log(result);
          if (result.data.data.address != null) {
            //console.log("passPIS");

            const data1 = AuthServiceV2.getCurrentUser().then(function (result) {
              setData(result.data.data);
              console.log(result);
            }).catch((error)=>{
              setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });

            })
          } else {
            console.log("passGDSNS");
            setcheckuserdata(true);
            setTimeout((e) => {
              setcheckuserdata(false);
              editdrone();
              //Navigate("/profile/editprofileuser");
            }, 3000);

            const data1 = AuthServiceV2.getCurrentUser().then(function (result) {
              setData(result.data.data);
              //console.log(result)
            }).catch((error)=>{
              setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });

            })
          }
          console.log(chooselicense);
        }).catch((error)=>{
          setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });

        })
    }
  }, []);
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    console.log(form);
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    event.preventDefault();
    setValidated(true);
  };
  return (
    <div //style={{background:"#E6E8EA",backgroundSize: "cover",height:"100%"}}
    >
      <div className="container font-cen" style={{ color: "black" }}>
        <h2
          style={{
            color: "#0077B6",
            position: "absolute",
            width: "676px",
            height: "69px",
            left: "50px",
            top: "130px",
            fontStyle: "normal",
            fontWeight: "700",
            fontSize: "46px",
            lineHeight: "69px",
          }}
        >
          ขอใบขึ้นทะเบียนเครื่องวิทยุคมนาคม
        </h2>
        &nbsp;
        <div style={myStyle}>
          <h3
            style={{
              color: "#0077B6",
              position: "absolute",
              width: "876px",
              height: "69px",
              left: "50px",
              top: "260px",
              fontStyle: "normal",
              fontWeight: "400",
              fontSize: "39px",
              lineHeight: "69px",
            }}
          >
            ข้อมูลอากาศยานที่ควบคุมการบินจากภายนอก
          </h3>
          <div>
            <Form
              ref={form1}
              noValidate
              validated={validated}
              onSubmit={(e) => handleSend(e)}
            >
              <Row
                className="mb-3"
                style={{
                  position: "absolute",
                  top: "350px",
                  left: "150px",
                  //width: "1608px",
                  width: "85%",
                  fontSize: "28px",
                }}
              >
                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    Serial Number<span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    id="drone_sn"
                    type="text"
                    placeholder="กรอกเลข serial number"
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      border: "1px solid",
                      borderRadius: "10px",
                      color: "black",
                    }}
                    value={droneserial}
                    onChange={(e) => {
                      setDroneserial(e.target.value);
                      //console.log(e.target.value);
                    }}
                  />
                </Form.Group>

                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    ตราอักษร<span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    id="drone_brand"
                    type="text"
                    placeholder="ตราอักษร"
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      border: "1px solid",
                      borderRadius: "10px",
                      color: "black",
                    }}
                    value={brand}
                    onChange={(e) => {
                      setBrand(e.target.value);
                    }}
                  />
                </Form.Group>

                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    รุ่น<span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    id="drone_model"
                    type="text"
                    placeholder="รุ่น"
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      border: "1px solid",
                      borderRadius: "10px",
                      color: "black",
                    }}
                    value={model}
                    onChange={(e) => {
                      setModel(e.target.value);
                    }}
                  />
                </Form.Group>
                {/* <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">NBTCID</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="NBTCID"
                    disabled
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      //border:"1px solid",
                      borderRadius: "10px",
                    }}
                  />
                </Form.Group> */}
                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    อุปกรณ์ที่ติดตั้ง(ถ้ามีโปรดระบุ)/installed accessories
                  </Form.Label>
                  <Form.Control
                    required
                    id="drone_install_eq"
                    type="text"
                    placeholder="ใบพัด,battery,Camera"
                    //disabled
                    style={{
                      height: "81px",
                      //width: "1620px",
                      fontSize: "28px",
                      border: "1px solid",
                      borderRadius: "10px",
                      color: "black",
                    }}
                    value={install_eq}
                    onChange={(e) => {
                      setInstall_eq(e.target.value);
                    }}
                  />
                </Form.Group>

                <Form.Group as={Col} md="12">
                  <Form.Label className="font-cen">
                    น้ำหนัก<span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <div>
                    <Form.Label className="font-cen">
                      {/* <Form.Check
                        required

                        type="radio"
                        name="option1"
                        value="0"
                        checked={weight === 0}
                        onChange={() => {
                          setWeight(parseInt(0));
                        }}
                      /> */}
                      <input
                        type="checkbox"
                        name="option1"
                        value="0"
                        checked={weight == 0}
                        onChange={() => {
                          setWeight(parseInt(0));
                        }}
                      />
                      &nbsp;"น้ำหนักไม่เกิน 2 กิโลกรัม"
                    </Form.Label>
                    <Form.Label className="font-cen">
                      <input
                        type="checkbox"
                        name="option1"
                        value="2"
                        checked={weight == 1}
                        onChange={() => {
                          setWeight(parseInt(1));
                        }}
                      />
                      &nbsp;"น้ำหนักเกินกว่า 2 กิโลกรัม แต่ไม่เกิน 25 กิโลกรัม"
                    </Form.Label>
                  </div>
                </Form.Group>

                <Form.Group as={Col} md="12">
                  <Form.Label className="font-cen">
                    มี Standard Remote ID<span style={{ color: "red" }}></span>
                  </Form.Label>
                  <div>
                    <Form.Label className="font-cen">
                      <input
                        type="checkbox"
                        name="standardRemoteID"
                        value="0"
                        checked={stdRemoteID === true}
                        onChange={() => {
                          if (stdRemoteID === false) {
                            setStdRemoteID(true);
                          } else {
                            setStdRemoteID(false);
                          }
                        }}
                      />
                      &nbsp;"มี Standard Remote ID"
                    </Form.Label>
                  </div>
                </Form.Group>

                <div className="card-main" style={{ height: "250px" }}>
                  <div style={{ display: "block" }}>
                    <Form.Label className="font-cen">
                      คลื่นความถี่ (MHz) และกำลังส่งออกอากาศสมมูลแบบไอโซทรอปิก *
                      / (Equivalent Isotropically Radiated Power : e.i.r.p)
                      Frequency and transmission power
                      <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                    <Form.Label className="font-censize">
                      <input
                        type="checkbox"
                        name="checkbox1"
                        value="0"
                        checked={frequency.checkbox1}
                        onChange={handleCheckboxChange}
                      />
                      &nbsp;433.05 – 434.79 MHz กำลังส่งสูงสุด e.i.r.p. 10 mW /
                      433.05 – 434.79 MHz Maximum transmission power 10 mW
                    </Form.Label>
                    <Form.Label className="font-censize">
                      <input
                        type="checkbox"
                        name="checkbox2"
                        value="1"
                        checked={frequency.checkbox2}
                        onChange={handleCheckboxChange}
                      />
                      &nbsp;2400 – 2500 MHz กำลังส่งสูงสุด e.i.r.p. 100 mW /
                      2400 – 2500 MHz Maximum transmission power 100 mW
                    </Form.Label>
                    <Form.Label className="font-censize">
                      <input
                        type="checkbox"
                        name="checkbox3"
                        value="2"
                        checked={frequency.checkbox3}
                        onChange={handleCheckboxChange}
                      />
                      &nbsp;5725 – 5850 MHz กำลังส่งสูงสุด e.i.r.p. 1000 mW /
                      5725 – 5850 MHz Maximum transmission power 1000 mW
                    </Form.Label>
                    <Form.Label className="font-censize">
                      <input
                        type="checkbox"
                        name="checkbox4"
                        value="3"
                        checked={frequency.checkbox4}
                        onChange={handleCheckboxChange}
                      />
                      &nbsp;24.05 – 24.25 GHz กำลังส่งสูงสุด e.i.r.p. 100 mW /
                      24.05 – 24.25 GHz Maximum transmission power 100 mW
                    </Form.Label>
                  </div>
                </div>
                <hr />
                <div className="card-main" style={{ height: "350px" }}>
                  <div style={{ display: "block" }}>
                    <Form.Label className="font-cen">
                      วัตถุประสงค์ของการใช้อากาศยาน / The purpose of using the
                      aircraft.<span style={{ color: "red" }}>*</span>
                    </Form.Label>
                    <Form.Label className="font-censize">
                      <input
                        type="checkbox"
                        name="checkbox1"
                        value={parseInt(0)}
                        checked={purpose[0]}
                        onChange={handleCheckboxpurposeChange}
                      />
                      &nbsp; เพื่อการเล่นเป็นงานอดิเรก ความบันเทิง หรือ
                      เพื่อการกีฬา
                    </Form.Label>
                    <Form.Label className="font-censize">
                      <input
                        type="checkbox"
                        name="checkbox2"
                        value={parseInt(0)}
                        checked={purpose[1]}
                        onChange={handleCheckboxpurposeChange}
                      />
                      &nbsp;เพื่อการรายงานเหตุการณ์หรือรายงานจราจร (สื่อมวลชน)
                    </Form.Label>
                    <Form.Label className="font-censize">
                      <input
                        type="checkbox"
                        name="checkbox3"
                        value={parseInt(0)}
                        checked={purpose[2]}
                        onChange={handleCheckboxpurposeChange}
                      />
                      &nbsp;เพื่อการถ่ายภาพ
                      ถ่ายทำหรือการแสดงในภาพยนต์หรือรายการโทรทัศน์
                    </Form.Label>
                    <Form.Label className="font-censize">
                      <input
                        type="checkbox"
                        name="checkbox4"
                        value={parseInt(0)}
                        checked={purpose[3]}
                        onChange={handleCheckboxpurposeChange}
                      />
                      &nbsp;เพื่อการวิจัยและพัฒนาอากาศยาน เพื่อการพาณิชย์
                    </Form.Label>
                    <Form.Label className="font-censize">
                      <input
                        type="checkbox"
                        name="checkbox5"
                        value={parseInt(0)}
                        checked={purpose[4]}
                        onChange={handleCheckboxpurposeChange}
                      />
                      &nbsp;เพื่อการเกษตรกรรม
                    </Form.Label>
                    <Form.Label className="font-censize">
                      <input
                        type="checkbox"
                        name="checkbox6"
                        value={parseInt(0)}
                        checked={purpose[5]}
                        onChange={handleCheckboxpurposeChange}
                      />
                      &nbsp;เพื่อการวิจัย ทดลอง ทดสอบ ตามประกาศ กสทช.
                    </Form.Label>
                    <Form.Label className="font-censize">
                      <input
                        type="checkbox"
                        name="checkbox7"
                        value={parseInt(0)}
                        checked={purpose[6]}
                        onChange={handleCheckboxpurposeChange}
                      />
                      &nbsp;กรณีมีวัตถุประสงค์อื่น ให้ระบุ
                    </Form.Label>
                    {purpose.checkbox7 === 1 && (
                      <Form.Label className="font-censize">
                        <input
                          type="text"
                          name="input"
                          value=""
                          checked={purpose.checkbox7 === 1}
                          onChange={handleCheckboxpurposeChange}
                          style={{ width: "400px" }}
                        />
                        &nbsp;
                      </Form.Label>
                    )}
                  </div>
                </div>
              </Row>
              <Row
                className="mb-3"
                style={{
                  position: "absolute",
                  top: "1570px",
                  left: "150px",
                  width: "85%",
                  fontSize: "28px",
                }}
              >
                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    แบรนด์อุปกรณ์ควบคุมการบิน
                    <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    type="text"
                    id="remote_brand"
                    placeholder="Ex. DJI"
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      border: "1px solid",
                      borderRadius: "10px",
                      color: "black",
                    }}
                    value={remote_brand}
                    onChange={(e) => {
                      setRemote_brand(e.target.value);
                    }}
                  />
                </Form.Group>

                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    หมายเลขประจำเครื่องอุปกรณ์ควบคุมการบิน
                    <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    id="remote_sn"
                    type="text"
                    placeholder="584819851841"
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      border: "1px solid",
                      borderRadius: "10px",
                      color: "black",
                    }}
                    value={remote_sn}
                    onChange={(e) => {
                      setRemote_sn(e.target.value);
                    }}
                  />
                </Form.Group>
              </Row>
              <Row
                className="mb-3"
                style={{
                  position: "absolute",
                  top: "1820px",
                  left: "150px",
                  width: "85%",
                  fontSize: "28px",
                }}
              >
                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    ประเภทกรมธรรม์<span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    id="ins_type"
                    type="text"
                    placeholder=""
                    //disabled
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      border: "1px solid",
                      borderRadius: "10px",
                      color: "black",
                    }}
                    value={ins_type}
                    onChange={(e) => {
                      setIns_type(e.target.value);
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    เลขกรมธรรม์<span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    id="ins_number"
                    type="text"
                    placeholder=""
                    //disabled
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      border: "1px solid",
                      borderRadius: "10px",
                      color: "black",
                    }}
                    value={ins_number}
                    onChange={(e) => {
                      setIns_number(e.target.value);
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    ชื่อบริษัทประกัน<span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    id="ins_company_name"
                    type="text"
                    placeholder=""
                    //disabled
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      border: "1px solid",
                      borderRadius: "10px",
                      color: "black",
                    }}
                    value={ins_company_name}
                    onChange={(e) => {
                      setIns_company_name(e.target.value);
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    วงเงินประกัน(ประกันภัยบุคคลที่ 3 วงเงินไม่ต่ำกว่า1ล้านบาท)
                    <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    id="ins_limit"
                    min={1000000}
                    maxLength="12"
                    type="number"
                    placeholder=""
                    //disabled
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      border: "1px solid",
                      borderRadius: "10px",
                      color: "black",
                    }}
                    value={ins_limit}
                    onChange={(e) => {
                      setIns_limit(parseInt(e.target.value));
                    }}
                  />
                  <Form.Control.Feedback type="invalid">
                    กรุณาใส่จำนวนวงเงินตั้งแต่ 1,000,000 บาทค่ะ
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    ระยะเวลาเริ่มประกัน<span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    id="ins_start"
                    type="date"
                    placeholder=""
                    //disabled
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      border: "1px solid",
                      borderRadius: "10px",
                      color: "black",
                    }}
                    value={ins_start}
                    onChange={(e) => {
                      setIns_start(e.target.value);
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    ระยะเวลาสิ้นสุดประกัน<span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    id="ins_end"
                    type="date"
                    placeholder=""
                    //disabled
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      border: "1px solid",
                      borderRadius: "10px",
                      color: "black",
                    }}
                    value={ins_end}
                    onChange={(e) => {
                      setIns_end(e.target.value);
                      console.log(e.target.value);
                    }}
                  />
                </Form.Group>
              </Row>
              <Row
                style={{
                  position: "absolute",
                  top: "2370px",
                  left: "150px",
                  width: "85%",
                  fontSize: "28px",
                }}
              >
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">คำนำหน้าชื่อ</Form.Label>

                  <Form.Control
                    disabled
                    value={data.title}
                    style={{
                      //width: "100%",
                      height: "81px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  ></Form.Control>
                </Form.Group>

                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">ชื่อ</Form.Label>
                  <Form.Control
                    required
                    disabled={disabless}
                    type="text"
                    value={data.f_name}
                    style={{
                      height: "81px",
                      //width: "100%",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">นามสกุล</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="text"
                    value={data.l_name}
                    style={{
                      height: "81px",
                      //width: "100%",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="12">
                  <Form.Label className="font-cen">เลขบัตรประชาชน</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="number"
                    //value="1-2345-12345-12-3"
                    value={data.idnum}
                    style={{
                      height: "81px",
                      //width: "1621px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">อีเมล</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="email"
                    //value="name@example.com"
                    value={data.email}
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">เบอร์โทรศัพท์</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="number"
                    aria-label="Amount (to the nearest dollar)"
                    value={data.phone}
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">อาชีพ</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="text"
                    value={data.occupation}
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="3">
                  <Form.Label className="font-cen">
                    วัน-เดือน-ปี เกิด
                  </Form.Label>
                  <Form.Control
                    disabled={disabless}
                    //type="date"
                    value={data.date_of_birth}
                    style={{
                      height: "81px",
                      //width: "345px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="3">
                  <Form.Label className="font-cen">อายุ</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="number"
                    value={data.age}
                    style={{
                      height: "81px",
                      //width: "345px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="3">
                  <Form.Label className="font-cen">เชื้อชาติ</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="text"
                    value={data.nationality}
                    style={{
                      height: "81px",
                      //width: "345px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="3">
                  <Form.Label className="font-cen">สัญชาติ</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="text"
                    value={data.nationality}
                    style={{
                      height: "81px",
                      //width: "345px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
              </Row>
              <Row
                className="mb-3"
                style={{
                  position: "absolute",
                  top: "3070px",
                  left: "150px",
                  width: "85%",
                  fontSize: "28px",
                }}
              >
                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    ที่อยู่(เลขที่, หมู่ที่, อาคาร, หมู่บ้าน, ซอย, ถนน)
                  </Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="text"
                    value={data.address}
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>

                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">จังหวัด</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="text"
                    value={data.province}
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">ตำบล</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="text"
                    value={data.sub_dis}
                    style={{
                      height: "81px",
                      //width: "483px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">อำเภอ</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="text"
                    value={data.dis}
                    style={{
                      height: "81px",
                      //width: "483px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">รหัสไปรษณีย์</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="number"
                    value={data.pos_code}
                    style={{
                      height: "81px",
                      //width: "486px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
              </Row>
              <Row
                className="mb-3"
                style={{
                  position: "absolute",
                  top: "3470px",
                  left: "150px",
                  width: "85%",
                  fontSize: "28px",
                }}
              >
                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    ที่อยู่(เลขที่, หมู่ที่, อาคาร, หมู่บ้าน, ซอย, ถนน)
                  </Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="text"
                    value={data.cur_address}
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>

                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">จังหวัด</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="text"
                    value={data.cur_province}
                    style={{
                      height: "81px",
                      //width: "770px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">ตำบล</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="text"
                    value={data.cur_sub_dis}
                    style={{
                      height: "81px",
                      //width: "483px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">อำเภอ</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="text"
                    value={data.cur_dis}
                    style={{
                      height: "81px",
                      //width: "483px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">รหัสไปรษณีย์</Form.Label>
                  <Form.Control
                    disabled={disabless}
                    type="number"
                    value={data.cur_poscode}
                    style={{
                      height: "81px",
                      //width: "486px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
              </Row>
              <Row
                className="mb-3"
                style={{
                  position: "absolute",
                  top: "3900px",
                  left: "150px",
                  width: "85%",
                  fontSize: "28px",
                }}
              >
                <div className="card-main ">
                  <div style={{ display: "block" }}>
                    <Form.Label className="font-censize">
                      <input
                        type="radio"
                        name="option1"
                        value="1"
                        checked={chooselicense == "1"}
                        onChange={handleOptionChange}
                      />
                      นำเข้าตามใบอนุญาตนำเข้า
                      <br />
                      Imported according to the Import License
                    </Form.Label>
                    <Form.Label className="font-censize">
                      <input
                        type="radio"
                        name="option2"
                        value="2"
                        checked={chooselicense === "2"}
                        onChange={handleOptionChange}
                      />
                      ซื้อจากร้านค้า
                      <br />
                      Purchased from the distributor/store
                    </Form.Label>
                    <Form.Label className="font-censize">
                      <input
                        type="radio"
                        name="option3"
                        value="3"
                        checked={chooselicense === "3"}
                        onChange={handleOptionChange}
                      />
                      นำเข้ามาใช้งานในประเทศเป็นการชั่วคราว
                      <br />
                      Temporarilty imported in to the country
                    </Form.Label>
                    <Form.Label className="font-censize">
                      <input
                        type="radio"
                        name="option4"
                        value="4"
                        checked={chooselicense === "4"}
                        onChange={handleOptionChange}
                      />
                      รับโอนจากบุคคลอื่น
                      <br />
                      Transfered from the others
                    </Form.Label>
                    <Form.Label className="font-censize">
                      <input
                        type="radio"
                        name="option5"
                        value="5"
                        checked={chooselicense === "5"}
                        onChange={handleOptionChange}
                      />
                      ทำขึ้นตามใบอนุญาต
                      <br />
                      Made according to the Assembly License
                    </Form.Label>
                  </div>
                  {chooselicense === "1" ? (
                    <div
                      style={{
                        position: "relative",
                        left: "15%",
                      }}
                    >
                      <Form.Label className="font-censize">
                        เลขใบอนุญาตนำเข้า<span className="text-red">*</span>
                        <br />
                        Import license number{" "}
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="file2"
                        //disabled
                        value={chooselicense === "1" ? lic_req_data : ""}
                        onChange={(e) => setLic_req_data(e.target.value)}
                        style={{
                          //height: "81px",
                          //width: "1609px",

                          fontSize: "28px",
                          borderRadius: "10px",
                          color: "black",
                        }}
                      />
                      <Form.Label className="font-censize">
                        วันที่นำเข้า (วัน/เดือน/ปี พ.ศ.)
                        <span className="text-red">*</span>
                        <br />
                        Import date (d M yyyy)
                      </Form.Label>
                      <Form.Control
                        required
                        type="date"
                        name="file2"
                        value={chooselicense === "1" ? lic_req_data1 : ""}
                        onChange={(e) => setLic_req_data1(e.target.value)}
                        //disabled
                        style={{
                          //height: "81px",
                          //width: "1609px",
                          fontSize: "28px",
                          borderRadius: "10px",
                          color: "black",
                        }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {chooselicense === "2" ? (
                    <div
                      style={{
                        position: "relative",
                        left: "400px",
                      }}
                    >
                      <Form.Label className="font-censize">
                        ชื่อร้านค้า<span className="text-red">*</span>
                        <br />
                        Store name{" "}
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="file2"
                        //disabled
                        value={chooselicense === "2" ? lic_req_data : ""}
                        onChange={(e) => setLic_req_data(e.target.value)}
                        style={{
                          //height: "81px",
                          //width: "1609px",
                          fontSize: "28px",
                          borderRadius: "10px",
                          color: "black",
                        }}
                      />
                      <Form.Label className="font-censize">
                        ตามใบเสร็จ/ใบกำกับภาษี ลงวันที่ (วัน/เดือน/ปี พ.ศ.)
                        <span className="text-red">*</span>
                        <br />
                        Bill date (d M yyyy)
                      </Form.Label>
                      <Form.Control
                        required
                        type="date"
                        name="file2"
                        //disabled
                        value={chooselicense === "2" ? lic_req_data1 : ""}
                        onChange={(e) => setLic_req_data1(e.target.value)}
                        style={{
                          //height: "81px",
                          //width: "1609px",
                          fontSize: "28px",
                          borderRadius: "10px",
                          color: "black",
                        }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {chooselicense === "3" ? (
                    <div
                      style={{
                        position: "relative",
                        left: "400px",
                      }}
                    >
                      <Form.Label className="font-censize">
                        วันที่เดินทางเข้าประเทศไทย/ Arrival date (mm dd, yyyy){" "}
                      </Form.Label>
                      <Form.Control
                        required
                        type="date"
                        name="date"
                        //disabled
                        onChange={(e) => setLic_req_data(e.target.value)}
                        style={{
                          //height: "81px",
                          //width: "1609px",
                          fontSize: "28px",
                          borderRadius: "10px",
                          color: "black",
                        }}
                      />
                      <Form.Label className="font-censize">
                        จำนวนวันที่พำนักในประเทศไทย (วัน)/
                        <span className="text-red">*</span>
                        <br />
                        Number of days of stay in Thailand (days)
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="date"
                        //disabled
                        onChange={(e) => setLic_req_data1(e.target.value)}
                        style={{
                          //height: "81px",
                          //width: "1609px",
                          fontSize: "28px",
                          borderRadius: "10px",
                          color: "black",
                        }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {chooselicense === "5" ? (
                    <div
                      style={{
                        position: "relative",
                        left: "400px",
                      }}
                    >
                      <Form.Label className="font-censize">
                        เลขที่ใบอนุญาตทำ<span className="text-red">*</span>
                        <br />
                        license number
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="file2"
                        //disabled
                        onChange={(e) => setLic_req_data(e.target.value)}
                        style={{
                          //height: "81px",
                          //width: "1609px",
                          fontSize: "28px",
                          borderRadius: "10px",
                          color: "black",
                        }}
                      />
                      <Form.Label className="font-censize">
                        วันที่ใบอนุญาตทำ (วัน/เดือน/ปี พ.ศ.)
                        <span className="text-red">*</span>
                        <br />
                        license date(d M yyyy)
                      </Form.Label>
                      <Form.Control
                        required
                        type="date"
                        name="date"
                        //disabled
                        onChange={(e) => setLic_req_data1(e.target.value)}
                        style={{
                          //height: "81px",
                          //width: "1609px",
                          fontSize: "28px",
                          borderRadius: "10px",
                          color: "black",
                        }}
                      />
                      <Form.Label className="font-censize">
                        วันที่ทำเครื่องวิทยุคมนาคม (วัน/เดือน/ปี พ.ศ.)
                        <span className="text-red">*</span>
                        <br />
                        made date radio communication device (d M yyyy)
                      </Form.Label>
                      <Form.Control
                        required
                        type="date"
                        name="date"
                        //disabled
                        onChange={(e) => setLic_req_data2(e.target.value)}
                        style={{
                          //height: "81px",
                          //width: "1609px",
                          fontSize: "28px",
                          borderRadius: "10px",
                          color: "black",
                        }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </Row>
              <Row
                className="mb-3"
                style={{
                  position: "absolute",
                  top: "4430px",
                  left: "150px",
                  width: "85%",
                  fontSize: "28px",
                }}
              >
                <Form.Group as={Col} md="12">
                  <Form.Label className="font-cen" style={{ fontSize: "40px" }}>
                    เอกสารแสดงตน
                  </Form.Label>
                  <Form.Label className="font-cen">
                    สำเนาบัตรประจำตัวประชาชน
                  </Form.Label>
                  <Form.Control
                    required
                    id="file1"
                    name="file1"
                    type="file"
                    //disabled={disabless}
                    style={{
                      height: "81px",
                      //width: "1609px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="12">
                  <Form.Label className="font-cen">สำเนาทะเบียนบ้าน</Form.Label>
                  <Form.Control
                    required
                    id="file2"
                    type="file"
                    name="file2"
                    //disabled
                    style={{
                      height: "81px",
                      //width: "1609px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="12">
                  <Form.Label className="font-cen" style={{ fontSize: "40px" }}>
                    เอกสารแสดงลักษณะทางเทคนิค
                  </Form.Label>
                  <Form.Label className="font-cen">
                    รูปถ่ายของ Drone / UAV’s picture
                  </Form.Label>
                  <Form.Control
                    required
                    id="file3"
                    type="file"
                    name="file2"
                    //disabled
                    style={{
                      height: "81px",
                      //width: "1609px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="12">
                  <Form.Label className="font-cen">
                    รูปถ่ายหมายเลขประจำเครื่อง Drone ที่เห็น QR CODE/Bar Code
                    ที่ชัดเจน <br />A photograph of the drone's serial number
                    with a clear QR Code / Bar Code.
                  </Form.Label>
                  <Form.Control
                    required
                    id="file4"
                    type="file"
                    name="file2"
                    //disabled
                    style={{
                      height: "81px",
                      //width: "1609px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="12">
                  <Form.Label className="font-cen">
                    รูปถ่ายหมายเลขประจำเครื่องอุปกรณ์ควบคุมการบิน Drone ที่เห็น
                    QR CODE/Bar Code ที่ชัดเจน
                    <br />A photograph of the remote controller's serial number
                    with a clear QR Code / Bar Code
                  </Form.Label>
                  <Form.Control
                    required
                    id="file5"
                    type="file"
                    name="file2"
                    //disabled
                    style={{
                      height: "81px",
                      //width: "1609px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="12">
                  <Form.Label className="font-cen">
                    หนังสือรับรองตนเอง
                  </Form.Label>
                  <Form.Control
                    required
                    id="file6"
                    type="file"
                    name="file2"
                    //disabled
                    style={{
                      height: "81px",
                      //width: "1609px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="12">
                  <Form.Label className="font-cen">
                    สำเนาเอกสารประกันภัยอากาศยาน
                  </Form.Label>
                  <Form.Control
                    required
                    id="file7"
                    type="file"
                    name="file2"
                    //disabled
                    style={{
                      height: "81px",
                      //width: "1609px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
                <hr />
                <Form.Group as={Col} md="12">
                  <Form.Label className="font-cen" style={{ fontSize: "40px" }}>
                    เอกสารหลักฐานเพิ่มเติมกรณีมอบอำนาจ
                  </Form.Label>
                  <Form.Label className="font-cen">
                    หนังสือมอบอำนาจ / Power of Attorney document
                  </Form.Label>
                  <Form.Control
                    //required
                    type="file"
                    name="file2"
                    //disabled
                    style={{
                      height: "81px",
                      //width: "1609px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="12">
                  <Form.Label className="font-cen">
                    สำเนาบัตรประจำตัวประชาชนผู้มอบอำนาจ / Copy of ID card of the
                    authorized person.
                  </Form.Label>
                  <Form.Control
                    //required
                    type="file"
                    name="file2"
                    //disabled
                    style={{
                      height: "81px",
                      //width: "1609px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="12">
                  <Form.Label className="font-cen">
                    สำเนาบัตรประจำตัวประชาชนผู้รับมอบอำนาจ / Copy of ID card of
                    the Attorney.
                  </Form.Label>
                  <Form.Control
                    //required
                    type="file"
                    name="file2"
                    //disabled
                    style={{
                      height: "81px",
                      //width: "1609px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
                <Form.Group as={Col} md="12">
                  <Form.Label className="font-cen" style={{ fontSize: "40px" }}>
                    เอกการดำเนินคดี
                  </Form.Label>
                  <Form.Label className="font-cen">
                    ผลการดำเนินคดี / Legal result
                  </Form.Label>
                  <Form.Control
                    //required
                    type="file"
                    name="file2"
                    //disabled
                    style={{
                      height: "81px",
                      //width: "1609px",
                      fontSize: "28px",
                      borderRadius: "10px",
                      color: "black",
                    }}
                  />
                </Form.Group>
              </Row>
              <Row>
                <h3
                  as={Col}
                  style={{
                    color: "#0077B6",
                    position: "absolute",
                    width: "876px",
                    height: "69px",
                    left: "50px",
                    top: "1510px",
                    fontStyle: "normal",
                    fontWeight: "400",
                    fontSize: "39px",
                    lineHeight: "69px",
                  }}
                >
                  ข้อมูลอุปกรณ์ควบคุมการบิน
                </h3>
              </Row>
              &nbsp;
              <div>
                <button
                  onClick={handleSend}
                  style={{
                    color: "white",
                    position: "absolute",
                    top: "6400px",
                    left: "75%",
                    width: "220px",
                    height: "87px",
                    background:
                      "linear-gradient(101.27deg, #023E8A 0%, #0096C7 100%)",
                    borderRadius: "27px",
                    fontSize: "31px",
                    borderWidth: "0px",
                    borderStyle: "solid",
                  }}
                >
                  นำส่งข้อมูล
                </button>
              </div>
            </Form>
            <Row>
              <h3
                as={Col}
                style={{
                  color: "#0077B6",
                  position: "absolute",
                  width: "876px",
                  height: "69px",
                  left: "50px",
                  top: "1730px",
                  fontStyle: "normal",
                  fontWeight: "400",
                  fontSize: "39px",
                  lineHeight: "69px",
                }}
              >
                เอกสารการประกันภัย
              </h3>
            </Row>
            <Row>
              <h3
                as={Col}
                style={{
                  color: "#0077B6",
                  position: "absolute",
                  width: "876px",
                  height: "69px",
                  left: "50px",
                  top: "2270px",
                  fontStyle: "normal",
                  fontWeight: "400",
                  fontSize: "39px",
                  lineHeight: "69px",
                }}
              >
                ข้อมูลผู้ขอขึ้นทะเบียน
              </h3>

              <Button
                onClick={editdrone}
                //disabled={!disabless}
                style={{
                  color: "black",
                  textAlign: "center",
                  position: "absolute",
                  width: "124px",
                  height: "49px",
                  left: "400px",
                  top: "2280px",
                  fontWeight: "400px",
                  lineHeight: "58px",
                  fontSize: "39px",
                  background:
                    "linear-gradient(97.29deg, #FDC43F 0%, #FCEC5D 100%)",
                  borderRadius: "79px",

                  borderWidth: "0px",
                  borderStyle: "solid",
                }}
              >
                <h4>แก้ไข</h4>
              </Button>
            </Row>
            &nbsp;
            <Row>
              <h3
                style={{
                  color: "#0077B6",
                  position: "absolute",
                  width: "876px",
                  height: "69px",
                  left: "50px",
                  top: "2980px",
                  fontStyle: "normal",
                  fontWeight: "400",
                  fontSize: "39px",
                  lineHeight: "69px",
                }}
              >
                ที่อยู่ตามบัตรประชาชนหรือทะเบียนบ้าน
              </h3>
            </Row>
            &nbsp;
            <Row>
              <h3
                style={{
                  color: "#0077B6",
                  position: "absolute",
                  width: "876px",
                  height: "69px",
                  left: "50px",
                  top: "3380px",
                  fontStyle: "normal",
                  fontWeight: "400",
                  fontSize: "39px",
                  lineHeight: "69px",
                }}
              >
                ที่อยู่ปัจจุบัน
              </h3>
            </Row>
            &nbsp;
            <Row>
              <h3
                style={{
                  color: "#0077B6",
                  position: "absolute",
                  width: "1276px",
                  height: "69px",
                  left: "50px",
                  top: "3780px",
                  fontStyle: "normal",
                  fontWeight: "400",
                  fontSize: "39px",
                  lineHeight: "69px",
                }}
              >
                วันที่ครอบครองเครื่องวิทยุคมนาคมที่ใช้ในอากาศยานซึ่งไม่มีนักบิน
              </h3>
            </Row>
            &nbsp;
            <h3
              style={{
                color: "#0077B6",
                position: "absolute",
                width: "876px",
                height: "69px",
                left: "50px",
                top: "4350px",
                fontStyle: "normal",
                fontWeight: "400",
                fontSize: "39px",
                lineHeight: "69px",
              }}
            >
              เอกสารที่นำส่ง
            </h3>
            <Form noValidate onSubmit={handleSubmit}>
            <Static_modal
        modalwaiting={modalToggle.modalwait}
        modalErr={modalToggle.modalErr}
        modalSuccess={modalToggle.modalSuccess}
        modalDenied={modalToggle.modalDenied}
        textBody={textBody}
        getHandle={handleClose_Modal}
      />
              <Modal
                show={updatedata}
                onHide={handleClose}
                className="font-cen"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>บันทึกข้อมูล</Modal.Title>
                </Modal.Header>
                <Modal.Body>ข้อมูลส่วนตัวจะถูกบันทึกใหม่</Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>
                    ยกเลิก
                  </Button>
                  <Button variant="primary" onClick={handleUpdatesuc}>
                    ยืนยัน
                  </Button>
                </Modal.Footer>
              </Modal>
              <Modal
                show={updatedatasuc}
                onHide={handleClose}
                className="font-cen"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>บันทึกข้อมูลสำเร็จ</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <img
                    src={check}
                    style={{
                      width: "100px",
                      height: "100px",
                      padding: "3%",
                      marginLeft: "180px",
                    }}
                  />
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>
                    ยกเลิก
                  </Button>
                </Modal.Footer>
              </Modal>
              <Modal
                show={show}
                onHide={handleClose}
                className="font-cen"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>นำส่งข้อมูลการขอขึ้นทะเบียน</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  ข้อมูลส่วนตัวจะถูกบันทึกใหม่และนำส่งข้อมูลการขอขึ้นทะเบียน
                  Drone
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>
                    ยกเลิก
                  </Button>
                  <Button variant="primary" onClick={handleSendsuc}>
                    นำส่งข้อมูล
                  </Button>
                </Modal.Footer>
              </Modal>
              <Modal
                show={senddata}
                onHide={handleClose}
                className="font-cen"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>นำส่งข้อมูลสำเร็จ</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <img
                    alt="check"
                    src={check}
                    style={{
                      width: "100px",
                      height: "100px",
                      padding: "3%",
                      marginLeft: "180px",
                    }}
                  />
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>
                    ปิด
                  </Button>
                  <Button variant="primary" onClick={next}>
                    ดูสถานะ
                  </Button>
                </Modal.Footer>
              </Modal>
              <Modal
                show={checkuserdata}
                centered
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                className="font-cen"
                //style={{ color: "red", background: "rgba(0,0,0,0.9)" }}
              >
                <Modal.Body
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    //background: "black",
                  }}
                >
                  <h3>no user data</h3>
                </Modal.Body>
              </Modal>
            </Form>
            &nbsp;
          </div>
        </div>
      </div>
    </div>
  );
}
export default StatusDronelast;
